import { CollectionsManager } from '../components/collections-manager.js';

/** The standalone page. The same manager also sits on the General settings tab. */
export function CollectionsManage() {
  return (
    <div className="editor">
      <h1>Manage Collections</h1>
      <section>
        <CollectionsManager />
      </section>
    </div>
  );
}
